/**
 * CSV-Erzeugung für die Lohn-Stundenliste (OPS-67).
 *
 * Format fürs Lohnbüro / deutsches Excel: Semikolon-Trenner, Dezimal-KOMMA,
 * UTF-8-BOM (sonst zeigt Excel Umlaute kaputt). Die Spaltenreihenfolge ist
 * mit dem Lohnbüro abzustimmen und danach STABIL zu halten — deren
 * Import-Vorlage hängt daran (BACKLOG OPS-67).
 */

export type PayrollCsvRow = {
  workerName: string;
  category: string;
  hours: number;
  percent?: number;
  amountCents?: number;
};

export const PAYROLL_CSV_HEADER = 'Monat;Mitarbeiter;Kategorie;Stunden;Zuschlag %;Betrag EUR';

export function categoryLabel(category: string): string {
  if (category === 'grund') return 'Grundstunden';
  if (category === 'nicht_abrechenbar') return 'davon nicht abrechenbar (Info)';
  if (category.startsWith('staffel:')) return `Staffel ${category.slice('staffel:'.length)}`;
  return category;
}

function deDecimal(value: number, fractionDigits: number): string {
  return value.toFixed(fractionDigits).replace('.', ',');
}

/** Semikolons/Zeilenumbrüche in Freitext-Zellen neutralisieren. */
function cell(value: string): string {
  return /[;"\n\r]/.test(value) ? `"${value.replace(/"/g, '""')}"` : value;
}

export function buildPayrollCsv(month: string, rows: readonly PayrollCsvRow[]): string {
  const lines = [PAYROLL_CSV_HEADER];
  for (const row of rows) {
    lines.push(
      [
        month,
        cell(row.workerName),
        cell(categoryLabel(row.category)),
        deDecimal(row.hours, 2),
        row.percent != null ? deDecimal(row.percent, 2) : '',
        row.amountCents != null ? deDecimal(row.amountCents / 100, 2) : '',
      ].join(';'),
    );
  }
  // BOM, damit Excel die Datei als UTF-8 erkennt.
  return `﻿${lines.join('\r\n')}\r\n`;
}

export function payrollCsvFilename(month: string): string {
  return `lohn-stundenliste-${month}.csv`;
}
